import IValidationService from '@core/services/betSlip/validation/IValidationService';
import IValidationResult from '@models/betSlip/validation/IValidationResult';
import ILottoBetSlipDTO from '@core/models/lottoBetSlip/ILottoBetSlipDto';
import ServerConfig from '@core/models/country/ServerConfig';
import { instanceGuard } from '@core/utils/services';
import SingletonError from '@core/services/common/errors/SingletonError';
import Singleton from '@core/services/common/Singleton';
import {
    LottoBetSlip,
    LottoBetSlipError,
    LottoBetSlipRestrictionsConfig,
    validateLottoBetSlip
} from '@superbet-group/betting.lib.validation';

class ValidationService implements IValidationService {

    private static instance: ValidationService;

    public static getInstance(): ValidationService {
        return instanceGuard(ValidationService.instance);
    }

    public static createInstance(config: ServerConfig) {
        if (!ValidationService.instance) {
            ValidationService.instance = new ValidationService(config);
        }
        return ValidationService.instance;
    }

    private constructor(private config: ServerConfig) {
        if (ValidationService.instance) {
            throw new SingletonError(this.constructor.name);
        }
    }

    public validate(betSlip: ILottoBetSlipDTO, isSubmit = false): IValidationResult {
        return {
            betSlipError: this.validateBetSlip(betSlip, isSubmit)[0] || null,
            selectionErrors: {}
        };
    }

    public static clearInstance() {
        if (process.env.NODE_ENV !== 'test') {
            throw new Error('For use in tests only');
        }
        delete ValidationService.instance;
    }

    private validateBetSlip(
        betSlip: ILottoBetSlipDTO,
        isSubmit: boolean,
    ): LottoBetSlipError[] {
        const betSlipConfig: LottoBetSlipRestrictionsConfig = {
            isEnabledEmptyBetSlip: true,
            maxStake: this.config.lottoBetSlip.stakeMax,
            minStake: this.config.lottoBetSlip.stakeMin,
            maxNumberOfSelections: this.config.lottoBetSlip.maxSelectedNumbers,
            isEnabledEventIsFinishedCheck: true,
        };

        return validateLottoBetSlip(
            mapBetSlip(betSlip),
            betSlipConfig,
            isSubmit,
        );
    }
}

export default ValidationService as Singleton<ValidationService>;

function mapBetSlip(betSlip: ILottoBetSlipDTO): LottoBetSlip {
    return {
        selections: betSlip.selections,
        stake: betSlip.stake,
        endBet: betSlip.endBet,
        candidateSelection: betSlip.candidateSelection,
        payout: betSlip.payout,
        rules: betSlip.rules as LottoBetSlip['rules'],
    };
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--12!./src/core/services/lottoBetSlip/validation/ValidationService.ts